/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * String object.
 *
 * @author Víctor Díaz <victor@axiomer.com>
 */
String.prototype.ucFirst = function () {
	return this.charAt(0).toUpperCase() + this.slice(1);
};